import Box from "@mui/material/Box";

import APDetailList from "../../components/APDetailList";
import { formatDate } from "../../helpers/dates";
import { Dossier } from "../../types/Dossier";

type DossierSummaryField =
  | "employee"
  | "employer"
  | "contractId"
  | "dossierIdentity"
  | "startDate"
  | "vehicle";

const DossierSummary = ({
  dossier,
  displayedFields,
}: {
  dossier: Dossier;
  displayedFields: DossierSummaryField[];
}) => {
  return (
    <Box>
      <APDetailList
        boldLabels={false}
        items={[
          ...(displayedFields.includes("employee") && dossier.crmContactName
            ? [
                {
                  label: "Employee",
                  value: `${dossier.crmContactName}${
                    dossier.contact?.employeeid
                      ? ` - ${dossier.contact.employeeid}`
                      : ""
                  }`,
                },
              ]
            : []),
          ...(displayedFields.includes("employer") &&
          dossier.opportunity?.parentAccountName
            ? [
                {
                  label: "Employer",
                  value: dossier.opportunity?.parentAccountName,
                },
              ]
            : []),
          ...(displayedFields.includes("contractId") &&
          dossier.opportunity?.catchEContractId
            ? [
                {
                  label: "Contract ID",
                  value: dossier.opportunity?.catchEContractId,
                },
              ]
            : []),
          ...(displayedFields.includes("dossierIdentity") && dossier.identity
            ? [
                {
                  label: "Dossier ID",
                  value: dossier.identity,
                },
              ]
            : []),
          ...(displayedFields.includes("startDate") && dossier.startDate
            ? [
                {
                  label: "Start Date",
                  value: formatDate(dossier.startDate),
                },
              ]
            : []),
          ...(displayedFields.includes("vehicle") &&
          dossier.vehicleMakeName &&
          dossier.vehicleModelName
            ? [
                {
                  label: "Vehicle",
                  value: `${dossier.vehicleModelyear} ${
                    dossier.vehicleMakeName
                  } ${dossier.vehicleModelName}${
                    dossier.vehicleRegistrationNumber
                      ? ` (${dossier.vehicleRegistrationNumber})`
                      : ""
                  }`,
                },
              ]
            : []),
        ]}
      />
    </Box>
  );
};

export default DossierSummary;
